import { twMerge } from 'tailwind-merge';
import { sortByUpdatedAt } from '@witmetrics/utils/arrays';
import { isEmpty } from '@witmetrics/utils/misc';
import { COLLECTION_VIEWS } from '@witmetrics/unison-core';
import FileItem from '../FileItem';
import FileCollectionItem from '../FileCollectionItem';
import type { BaseFileCollectionProps } from '../types';
import { classes } from './utils';

export interface FileCollectionGridProps extends BaseFileCollectionProps {
  onOpenFileCollection?: (fileCollectionId: number) => void;
}

export default function FileCollectionGrid({
  isFetchingData, // TODO
  variant,
  className,
  fileCollections,
  files,
  onOpenFileCollection,
  onViewFileCollection,
  onViewFile,
  onDeleteFileCollection,
  onDeleteFile,
}: FileCollectionGridProps) {
  const isAurora = variant === 'aurora';
  return (
    <>
      {!isEmpty(fileCollections) && (
        <div
          className={twMerge(
            isAurora
              ? twMerge(classes.auroraGrid, classes.auroraFolderGrid)
              : classes.grid,
            className
          )}>
          {sortByUpdatedAt(fileCollections!).map((fc) => (
            <FileCollectionItem
              key={`collection_${fc.id}`}
              showDetails
              fileCollectionId={fc.id}
              variant={variant}
              view={COLLECTION_VIEWS.GRID}
              onViewFile={onViewFile}
              onViewFileCollection={onViewFileCollection}
              onOpenFileCollection={onOpenFileCollection}
              onDelete={() => onDeleteFileCollection?.(fc.id)}
            />
          ))}
        </div>
      )}
      <div
        className={twMerge(
          isAurora
            ? twMerge(classes.auroraGrid, classes.auroraFileGrid)
            : classes.grid,
          className
        )}>
        {sortByUpdatedAt(files!).map((f) => (
          <FileItem
            key={`file_${f.id}`}
            showDetails
            fileId={f.id}
            variant={variant}
            view={COLLECTION_VIEWS.GRID}
            onSelect={onViewFile}
            onDelete={() => onDeleteFile?.(f.id)}
          />
        ))}
      </div>
    </>
  );
}
